<template>
  <q-form ref="form" class="full-width q-pa-md">
    <div class="row items-center">
      <div class="col-12 q-mb-sm" v-if="formData.hasOwnProperty('id')">
        <q-btn
          v-if="!formData.end_ts"
          color="secondary"
          unelevated
          text-color="accent"
          no-caps
          class="q-mr-sm"
          @click="endOwnership"
          :loading="endOwnershipLoading"
        >
          <q-icon size="xs" name="mdi-cancel" class="q-mr-sm"></q-icon>
          End Ownership
        </q-btn>
      </div>
      <div v-if="!formData.hasOwnProperty('id')" class="col-12 q-px-sm">
        <assignOrganization
          :id="organization"
          :emitValue="false"
          @changed="updateOrganization"
        />
      </div>
      <div
        v-if="!formData.hasOwnProperty('id') && organization"
        class="col-12 q-px-sm"
      >
        <assignDevice
          :id="formData.devices_id"
          :disable="!organization.applications_id"
          :filterApplicationsID="organization.applications_id"
          @changed="(val) => (formData.devices_id = val)"
        />
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";
  import assignOrganization from "@/components/organizations/assignOrganization.vue";
  import assignDevice from "@/components/devices/assignDevice.vue";

  export default {
    components: { assignOrganization, assignDevice },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
      }),
    },
    props: {
      data: {
        type: Object,
        default: null,
      },
    },
    watch: {
      data: function () {
        this.init();
      },
    },
    data: () => ({
      // Extra Data
      organization: null,
      formData: {
        organizations_id: null,
      },

      endOwnershipLoading: false,
    }),
    beforeCreate() {
      this.$store.dispatch("organizations/loadAll");
      this.$store.dispatch("devices/loadAll");
    },
    mounted() {
      setTimeout(() => {
        this.init();
      }, 100);
    },
    methods: {
      init() {
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {
            organizations_id: null,
          };
        }
      },
      create() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$refs.form.validate().then((result) => {
            if (result) {
              this.$store
                .dispatch("ownerships/new", this.formData)
                .then((result) => {
                  this.$emit("loadingStateChanged", false);
                  if (result.Result == "Success") {
                    this.$emit("close", true);
                    this.formData = {};
                    this.$q.notify({
                      position: "top-right",
                      type: "positive",
                      message: result.Response.Message,
                    });
                  } else {
                    this.$q.notify({
                      position: "top-right",
                      type: "negative",
                      message: result.Response.Message,
                    });
                  }
                });
            } else {
              this.$emit("loadingStateChanged", false);
            }
          });
        }, 200);
      },
      save() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$store
            .dispatch("ownerships/save", {
              id: this.formData.id,
            })
            .then((result) => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.address = "";
                this.$emit("close", true);
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message,
                });
              }
            });
        });
      },
      updateOrganization(val) {
        this.organization = val;
        this.formData.organizations_id = val.id;
      },
      endOwnership() {
        this.endOwnershipLoading = true;
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$store
              .dispatch("ownerships/end", {
                id: this.formData.id,
              })
              .then((result) => {
                this.endOwnershipLoading = false;
                if (result.Result == "Success") {
                  this.$emit("close", true);
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.endOwnershipLoading = false;
          }
        });
      },
    },
  };
</script>
